export const stringToPath = (str: string, clear: boolean = false) => {
  if (typeof str !== "string") return str
  if (clear) {
    str = str.replace(/[^a-zA-Z0-9 ]/g, "")
  }
  return str.replace(/\//g, "").toLowerCase().split(" ").join("-")
}

export const pathToString = (path: string) => {
  return path
    .replace(/\//g, "")
    .split("-")
    .map((word) => word.charAt(0).toLocaleUpperCase() + word.slice(1))
    .join(" ")
}
